import * as yup from 'yup';

export const schema = yup.object({
  cod_cst_ibs_cbs: yup
    .object({
      value: yup.number().required(),
      label: yup.string().required(),
    })
    .required(),
  des_classif_trib: yup
    .string()
    .notRequired()
    .length(6, 'É necessário informar 6 dígitos para a Classificação'),
  des_ibs_cbs: yup.string().trim().required(),
  per_aliq_cbs: yup.string().notRequired(),
  per_red_cbs: yup.string().notRequired(),
  val_red_social: yup.string().notRequired(),
});

export const schemaUF = yup.object({
  des_sigla: yup
    .object({
      value: yup.number().required(),
      label: yup.string().required(),
    })
    .required(),
  per_aliq_ibs_est: yup.string().notRequired(),
  per_aliq_ibs_mun: yup.string().notRequired(),
  per_red_ibs: yup.string().notRequired(),
});

export const schemaModalCST = yup.object({
  des_cst_ibs_cbs: yup.string().required(),
  cst_ibs_cbs: yup
    .string()
    .min(3)
    .max(3)
    .matches(/^\d{3}$/)
    .required(),
});
